import React, { useEffect } from "react";

const Companysteps = ({ currentStep, setCurrentFormStep }) => {
  const onStepClick = (stepToMove) => {
    setCurrentFormStep(stepToMove);
  };
  return (
    <div className="row bs-wizard" style={{ borderBottom: 0 }}>
      <div
        className={
          currentStep >= 1
            ? "col-4 bs-wizard-step complete "
            : "col-4 bs-wizard-step"
        }
      >
        <div className="text-center bs-wizard-stepnum">Step 1</div>
        <div className="progress">
          <div className="progress-bar"></div>
        </div>
        <a
          onClick={() => {
            onStepClick(1);
          }}
          className="bs-wizard-dot"
        ></a>
      </div>
      <div
        className={
          currentStep >= 2
            ? "col-4 bs-wizard-step complete "
            : "col-4 bs-wizard-step disabled"
        }
      >
        <div className="text-center bs-wizard-stepnum">Step 2</div>
        <div className="progress">
          <div className="progress-bar"></div>
        </div>
        <a
          onClick={() => {
            onStepClick(2);
          }}
          className="bs-wizard-dot"
        ></a>
      </div>
      <div
        className={
          currentStep >= 3
            ? "col-4 bs-wizard-step complete "
            : "col-4 bs-wizard-step disabled"
        }
      >
        <div className="text-center bs-wizard-stepnum">Step 3</div>
        <div className="progress">
          <div className="progress-bar"></div>
        </div>
        <a
          onClick={() => {
            onStepClick(3);
          }}
          className="bs-wizard-dot"
        ></a>
      </div>
    </div>
  );
};
export default Companysteps;
